// Standard light/moderate/heavy rain-rate thresholds (mm/h), as used by the
// UK Met Office and NOAA, applied to OpenWeather's rain["1h"] reading.
export function classifyRainIntensity(rain) {
  if (!rain) return "none";
  const mmPerHour = rain["1h"] ?? (rain["3h"] ? rain["3h"] / 3 : 0);
  if (mmPerHour <= 0) return "none";
  if (mmPerHour < 2.5) return "light";
  if (mmPerHour < 7.6) return "moderate";
  return "heavy";
}
